import { ExperimentalLabel } from "@/components";
import { useDialogModal } from "@/ui/dialogs/useDialogModal";
import { Suspense, lazy } from "react";
import { SectionProvider } from "../section";

// Lazy load AutoSectionModal to break circular dependency
const AutoSectionModal = lazy(() =>
  import("./AutoSectionModal").then((module) => ({ default: module.AutoSectionModal })),
);

export const useAutoSectionModal = () => {
  const { openDialogModal } = useDialogModal();
  return ({ source, onInsert, documentId }) => {
    openDialogModal(
      {
        title: (
          <div className="flex items-center gap-4">
            <span>Suggest source sections</span>
            <ExperimentalLabel />
          </div>
        ),
        maxWidth: "xl",
      },
      <SectionProvider documentId={documentId}>
        <Suspense fallback={null}>
          <AutoSectionModal
            source={source}
            onInsert={onInsert}
            documentId={documentId}
          />
        </Suspense>
      </SectionProvider>,
    );
  };
};
